import Vue from 'vue';


import GoogleMapsApiLoader from 'google-maps-api-loader'



if (document.querySelector('#lists-show-vue')) {

    new Vue({
        name: 'List Spots Page',
        el: '#lists-show-vue',
        // router,
        async mounted() {
            const googleMapApi = await GoogleMapsApiLoader({
                libraries: ['places'],
                apiKey: process.env.MIX_MAPS_API_KEY,
            })
            eventBus.$emit('google-api-is-ready', googleMapApi)
        }
    });
}


